import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0180f73c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asahi-progress-bar",
  ref: "progressBar"
}
const _hoisted_2 = { class: "bottle-container rounded-2" }
const _hoisted_3 = { class: "d-flex align-items-center flex-column" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "options-container-title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_9 = { class: "options-container-title" }
const _hoisted_10 = { class: "options-container-message" }
const _hoisted_11 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_12 = { class: "options-container-title" }
const _hoisted_13 = { class: "options-container-message" }
const _hoisted_14 = {
  key: 2,
  class: "fw-normal"
}
const _hoisted_15 = { class: "options-container-title" }
const _hoisted_16 = { class: "options-container-message" }
const _hoisted_17 = {
  key: 3,
  class: "fw-normal"
}
const _hoisted_18 = { class: "options-container-title" }
const _hoisted_19 = { class: "options-container-message" }
const _hoisted_20 = { class: "d-flex align-items-center mt-1" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "d-flex gap-3" }
const _hoisted_23 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_24 = { class: "fw-medium" }
const _hoisted_25 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_26 = { class: "fw-medium" }
const _hoisted_27 = {
  key: 2,
  class: "fw-normal"
}
const _hoisted_28 = { class: "fw-medium" }
const _hoisted_29 = {
  key: 3,
  class: "fw-normal"
}
const _hoisted_30 = { class: "fw-medium" }
const _hoisted_31 = {
  key: 1,
  class: "asahi-progress-bar-message-no-bg d-flex gap-1 align-items-start w-100"
}
const _hoisted_32 = { class: "d-flex align-items-center mt-3" }
const _hoisted_33 = { class: "gap-3 w-100 mt-2" }
const _hoisted_34 = { class: "row py-1 mb-2" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "row py-1" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 0,
  class: "row py-1"
}
const _hoisted_39 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = {
  key: 1,
  class: "row py-1 mt-1"
}
const _hoisted_42 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = {
  key: 2,
  class: "row py-1 mt-1"
}
const _hoisted_45 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_46 = { class: "" }
const _hoisted_47 = {
  key: 3,
  class: "row py-1 mt-1"
}
const _hoisted_48 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = {
  key: 2,
  class: "asahi-progress-bar-message-no-bg d-flex gap-1 align-items-start w-100"
}
const _hoisted_51 = { class: "d-flex align-items-center mt-3" }
const _hoisted_52 = { class: "gap-3 w-100 mt-2" }
const _hoisted_53 = { class: "row py-1 mb-2" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "row py-1" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = {
  key: 1,
  class: "asahi-progress-bar"
}
const _hoisted_58 = { class: "w-100 rounded-2" }
const _hoisted_59 = { class: "d-flex align-items-center flex-column" }
const _hoisted_60 = { class: "d-flex gap-2 align-items-center justify-content-start w-100" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = { class: "d-flex align-items-start gap-1" }
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 1,
  class: "asahi-compact-message pt-2"
}
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = {
  key: 1,
  class: "asahi-compact-details d-flex flex-column gap-3 mt-2"
}
const _hoisted_69 = { class: "d-flex justify-content-between" }
const _hoisted_70 = { class: "fw-medium text-center" }
const _hoisted_71 = { class: "d-flex justify-content-between" }
const _hoisted_72 = { class: "fw-medium text-center" }
const _hoisted_73 = {
  key: 2,
  class: "asahi-compact-details d-flex flex-column gap-3 mt-2"
}
const _hoisted_74 = { class: "d-flex justify-content-between" }
const _hoisted_75 = { class: "fw-medium text-center" }
const _hoisted_76 = { class: "d-flex justify-content-between" }
const _hoisted_77 = { class: "fw-medium text-center" }
const _hoisted_78 = { key: 3 }
const _hoisted_79 = { class: "asahi-mini-container" }
const _hoisted_80 = { class: "d-flex align-items-start gap-1" }
const _hoisted_81 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AllertCart = _resolveComponent("AllertCart")!
  const _component_SuccessCart = _resolveComponent("SuccessCart")!
  const _component_AsahiProgress = _resolveComponent("AsahiProgress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.messageType != 'mini' && _ctx.messageType != 'icon-only')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.progressBarMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.messageType === 'header')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "fw-normal",
                      innerHTML: _ctx.progressBarMessage.title
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_AsahiProgress, {
                "is-white": _ctx.isWhite,
                barHeight: "4",
                percentage: _ctx.getFillPercentage(),
                success: _ctx.progressBarMessage?.hasSucccess === true
              }, null, 8, ["is-white", "percentage", "success"]),
              _createElementVNode("div", {
                class: _normalizeClass(["options-container py-3", {'in-homepage' : _ctx.isHomePge}])
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Order Capacity')), 1),
                _createElementVNode("div", {
                  class: "d-flex align-items-center gap-1 options-container-message",
                  innerHTML: _ctx.progressBarMessage.subtitle
                }, null, 8, _hoisted_7),
                (!_ctx.isWHSUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Minimum units:')), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.minimumOrderUnits), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isWHSUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('Maximum units:')), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.maximumOrderUnits), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isWHSUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Minimum number of pallets:')), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.minimumOrderPallett), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isWHSUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('Maximum weight')), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalCartWeight) + " Kg/ " + _toDisplayString(_ctx.maximumOrderWeight) + " Kg ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 512), [
            [_vShow, _ctx.messageType === 'header']
          ]),
          (_ctx.messageType === 'long')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asahi-progress-bar-message d-flex gap-1 align-items-start", _ctx.messageColorClass])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "d-flex align-items-center gap-1 fw-normal",
                    innerHTML: _ctx.progressBarMessage.subtitle
                  }, null, 8, _hoisted_21),
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.isWHSUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Minimum number of pallets:')) + " ", 1),
                          _createElementVNode("span", _hoisted_24, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.minimumOrderPallett), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isWHSUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Maximum weight')) + " ", 1),
                          _createElementVNode("span", _hoisted_26, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.totalCartWeight) + " Kg/ " + _toDisplayString(_ctx.maximumOrderWeight) + " Kg", 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isWHSUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Minimum units:')) + " ", 1),
                          _createElementVNode("span", _hoisted_28, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.minimumOrderUnits), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isWHSUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Maximum units:')) + " ", 1),
                          _createElementVNode("span", _hoisted_30, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.maximumOrderUnits), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.messageType === 'mobile-long')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 20,
                        "width-value": 20
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 20,
                        "width-value": 20,
                        "is-white": true,
                        "is-bg-green": true
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", {
                      class: "col-12 asahi-compact-message",
                      innerHTML: _ctx.progressBarMessage?.subtitle
                    }, null, 8, _hoisted_35)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", {
                      class: "col-12 asahi-compact-message fw-extrabold",
                      innerHTML: _ctx.progressBarMiniMessage?.expendedTitle
                    }, null, 8, _hoisted_37)
                  ]),
                  _createVNode(_component_AsahiProgress, {
                    "is-white": _ctx.isWhite,
                    barHeight: "4",
                    class: "mb-3",
                    percentage: _ctx.getFillPercentage(),
                    success: _ctx.progressBarMessage?.hasSucccess === true
                  }, null, 8, ["is-white", "percentage", "success"]),
                  (_ctx.isWHSUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Number of pellets:')) + " ", 1),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.minimumOrderPallett), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isWHSUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Weight')) + ": ", 1),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(parseInt(_ctx.totalCartWeight)) + " / " + _toDisplayString(_ctx.maximumOrderWeight) + " Kg", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isWHSUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Minimum units:')) + " ", 1),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.minimumOrderUnits), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isWHSUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Maximum units:')) + " ", 1),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.maximumOrderUnits), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.messageType === _ctx.mobileCart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 20,
                        "width-value": 20
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 20,
                        "width-value": 20,
                        "is-white": true,
                        "is-bg-green": true
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", {
                      class: "col-12 asahi-mobile-cart",
                      innerHTML: _ctx.progressBarMessage?.subtitle
                    }, null, 8, _hoisted_54)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", {
                      class: "col-12 asahi-mobile-cart fw-extrabold",
                      innerHTML: _ctx.progressBarMiniMessage?.expendedTitle
                    }, null, 8, _hoisted_56)
                  ]),
                  _createVNode(_component_AsahiProgress, {
                    "is-white": _ctx.isWhite,
                    barHeight: "4",
                    class: "mb-3",
                    percentage: _ctx.getFillPercentage(),
                    success: _ctx.progressBarMessage?.hasSucccess === true
                  }, null, 8, ["is-white", "percentage", "success"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'mobile')
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                (_ctx.progressBarMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 16,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14,
                      "is-white": true,
                      "is-bg-green": true
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "fw-extrabold",
                  innerHTML: _ctx.progressBarMiniMessage.title
                }, null, 8, _hoisted_61)
              ]),
              _createVNode(_component_AsahiProgress, {
                "is-white": _ctx.isWhite,
                barHeight: "4",
                percentage: _ctx.getFillPercentage(),
                success: _ctx.progressBarMessage?.hasSucccess === true
              }, null, 8, ["is-white", "percentage", "success"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'compact')
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["asahi-compact-container fs-6", {
      'border-default-text': !_ctx.isMobile && !(_ctx.progressBarMessage?.hasError || _ctx.progressBarMessage?.hasSucccess),
      'border-error-text': !_ctx.isMobile && _ctx.progressBarMessage?.hasError,
      'border-success-text': !_ctx.isMobile && _ctx.progressBarMessage?.hasSucccess
     }])
        }, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              (_ctx.progressBarMessage?.hasError)
                ? (_openBlock(), _createBlock(_component_AllertCart, {
                    key: 0,
                    "height-value": 17,
                    "width-value": 14
                  }))
                : _createCommentVNode("", true),
              (_ctx.progressBarMessage?.hasSucccess)
                ? (_openBlock(), _createBlock(_component_SuccessCart, {
                    key: 1,
                    "height-value": 17,
                    "width-value": 14
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "asahi-compact-title",
              innerHTML: _ctx.progressBarMessage.title
            }, null, 8, _hoisted_64)
          ]),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "asahi-compact-title",
                innerHTML: _ctx.progressBarMessage.mobileTitle
              }, null, 8, _hoisted_65))
            : _createCommentVNode("", true),
          _createVNode(_component_AsahiProgress, {
            class: "mt-2 mb-2",
            "is-white": _ctx.isWhite,
            barHeight: "4",
            percentage: _ctx.getFillPercentage()
          }, null, 8, ["is-white", "percentage"]),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                (!_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "d-block",
                      innerHTML: _ctx.progressBarMessage.subtitle
                    }, null, 8, _hoisted_67))
                  : _createCommentVNode("", true),
                (_ctx.isWHSUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Minimum number of pallets:')) + " ", 1),
                        _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.minimumOrderPallett), 1)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Maximum weight:')) + " ", 1),
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.totalCartWeight) + " Kg/ " + _toDisplayString(_ctx.maximumOrderWeight) + " Kg ", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPosHorecaUser || _ctx.isPosFoodUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Minimum units:')) + " ", 1),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.minimumOrderUnits), 1)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Maximum units:')) + " ", 1),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.totalCartUnits) + " / " + _toDisplayString(_ctx.maximumOrderUnits), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'mini')
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", null, [
                (_ctx.progressBarMiniMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMiniMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "asahi-compact-message",
                innerHTML: _ctx.progressBarMiniMessage.title
              }, null, 8, _hoisted_81)
            ]),
            _createVNode(_component_AsahiProgress, {
              "is-white": _ctx.isWhite,
              barHeight: "4",
              percentage: _ctx.getFillPercentage()
            }, null, 8, ["is-white", "percentage"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.progressBarMessage?.hasError && _ctx.messageType === "icon-only")
      ? (_openBlock(), _createBlock(_component_AllertCart, {
          key: 4,
          "height-value": 17,
          "width-value": 14
        }))
      : _createCommentVNode("", true),
    (_ctx.progressBarMessage?.hasSucccess && _ctx.messageType === "icon-only")
      ? (_openBlock(), _createBlock(_component_SuccessCart, {
          key: 5,
          "height-value": 17,
          "width-value": 14,
          "is-white": true,
          "is-bg-green": true
        }))
      : _createCommentVNode("", true)
  ], 64))
}